import React, { useState, useEffect } from 'react';
import { Modal, Input, Button, Form, List, Divider, Popconfirm } from 'antd';
import moment from 'moment';
import { getNotes, writeNote } from "../../../api/Cards"
import { useTranslation } from "react-i18next"

export const ServiceNotes = ({ Card, onClose }) => {
    const [form] = Form.useForm();
    const [notes, setNotes] = useState([]);
    const { t } = useTranslation()
    const user = null;

    useEffect(() => {
        fetchData()

        if (user) {
            const userNotes = user.notes.map(note => ({
                ...note,
                date: note.date || moment().format('YYYY-MM-DD HH:mm:ss')
            }));
            setNotes(userNotes);
            form.setFieldsValue({ note: '' });
        }
    }, [user, form]);

    const handleSave = async () =>
    {
        try {
            const values = await form.validateFields();
            const newNote = {
                id: notes.length + 1,
                text: values.note,
                date: moment().format('YYYY-MM-DD HH:mm:ss')
            };

            writeNote({ Card: Card, Text: newNote.text, Date: newNote.date });

            const updatedNotes = [newNote, ...notes];
            setNotes(updatedNotes);
            //onSave(user.id, newNote);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const handleDelete = (noteId) =>
    {
        const updatedNotes = notes.filter(note => note.id !== noteId);
        setNotes(updatedNotes);
        //onDelete(user.id, noteId);
    };

    const fetchData = async () =>
    {
        const data = await getNotes(Card);

        if (typeof data === "number") {
            console.log("Disconnect: ", data)
            return;
            //navigate('/dashboard');
        }

        const userNotes = data.map(note => ({
            date: note.Date,
            text: note.Text,
            id: note.Index
        }));

        setNotes(userNotes);
    };

    return (
        <Modal
            open={true}
            title={t('page.carddetails.servicenotes.title')}
            onCancel={onClose}
            footer={null}
        >
            <Form form={form}>
                <Form.Item
                    name="note"
                    rules={[{ required: true, message: t('page.carddetails.servicenotes.writenew') }]}
                >
                    <Input.TextArea rows={4} placeholder={t('page.carddetails.servicenotes.writenew')} />
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                    <Button key="save" type="primary" onClick={handleSave}>
                        {t('page.carddetails.servicenotes.add')}
                    </Button>
                </Form.Item>
            </Form>
            <Divider />
            <List
                header={<div style={{ fontWeight: 'bold' }}>{t('page.carddetails.servicenotes.prev')}</div>}
                bordered
                dataSource={notes}
                renderItem={item => (
                    <List.Item key={item.id}>
                        <div>
                            <div>{item.text}</div>
                            <div style={{ fontSize: 'smaller', color: 'grey', marginTop: 4 }}>{item.date}</div>
                        </div>
                    </List.Item>
                )}
            />
        </Modal>
    );
}
export default ServiceNotes
